module.exports = __webpack_public_path__ + "statics/img/3-8.a9922ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/3-8.png
// module id = 2+i6
// module chunks = 1